import React, { useMemo } from 'react';
import ReactSelect, { components } from 'react-select';

const CustomOption = (props) => {
  const { data } = props;

  return (
    <components.Option {...props}>
      <div className="flex flex-col">
        <span className="text-sm font-medium">{data?.label}</span>
        {data.description && <span className="text-xs text-gray-400">{data.description}</span>}
      </div>
    </components.Option>
  );
};

const Dropdown = ({
  label,
  className = '',
  value,
  onChange,
  options = [],
  placeholder = 'Выберите...',
  disabled = false,
  isClearable = false,
  isSearchable = true,
  valkey = 'value',
  optkey = 'label',
  optkey2,
  emptyMessage = 'Нет доступных опций',
  hasError = false,
  ...restProps
}) => {
  const formattedOptions = useMemo(
    () =>
      options.map((option) => ({
        value: option[valkey],
        label: option[optkey],
        description: option[optkey2],
      })),
    [options, valkey, optkey, optkey2]
  );

  const selectedOption = formattedOptions.find((opt) => opt.value === value) || null;

  const customStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: '40px',
      borderRadius: '20px',
      borderColor: hasError ? '#ef4444' : state.isFocused ? '#9ca3af' : '#d1d5db',
      backgroundColor: 'white',
      cursor: disabled ? 'not-allowed' : 'pointer',
      boxShadow: 'none',
      '&:hover': {
        borderColor: hasError ? '#ef4444' : '#9ca3af',
      },
    }),
    placeholder: (base) => ({
      ...base,
      color: '#9ca3af',
      fontSize: '14px',
    }),
    valueContainer: (base) => ({
      ...base,
      paddingLeft: '12px',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: '8px 16px 8px 8px',
      color: '#6b7280',
    }),
    menu: (base) => ({
      ...base,
      borderRadius: '8px',
      zIndex: 9999,
      overflow: 'hidden',
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? '#e5e7eb' : state.isFocused ? '#f3f4f6' : '#ffffff',
      color: '#1f2937',
      cursor: 'pointer',
      fontSize: '14px',
      padding: '12px',
    }),
  };

  return (
    <div className={className}>
      {label && <label className={`block text-sm ml-2 mb-2 ${disabled ? 'text-gray-400' : 'text-gray-700'}`}>{label}</label>}
      <ReactSelect
        value={selectedOption}
        onChange={(option) => onChange?.(option ? option.value : null)}
        options={formattedOptions}
        components={{ Option: CustomOption }}
        placeholder={placeholder}
        isDisabled={disabled}
        isClearable={isClearable}
        isSearchable={isSearchable}
        noOptionsMessage={() => emptyMessage}
        styles={customStyles}
        classNamePrefix="react-select"
        {...restProps}
      />
    </div>
  );
};

export default Dropdown;
